import AppLayout from "./layouts/appLayout";
import AuthLayout from "./layouts/authLayout";
import EmptyLayout from "./layouts/emptyLayout";
import NotFoundPage from "./pages/404";
import LoginPage from "./pages/auth/login";
import RegisterPage from "./pages/auth/register";
import RegisterSuccess from "./pages/auth/registerSuccess";
import HomePage from "./pages/dashboard/home";
import HelpHomePage from "./pages/help";
import MaintenanceHomePage from "./pages/maintenance";
import MessagesHomePage from "./pages/messages";
import PropertyHomePage from "./pages/property";
import PropertyAddPage from "./pages/property/add";
import SingleProperty from "./pages/property/singleProperty";
import UnitAddPage from "./pages/property/unit/add";
import UnitEditPage from "./pages/property/unit/edit";
import SingleUnit from "./pages/property/unit/singleUnit";
import RequestsHomePage from "./pages/requests";
import RequestAddPage from "./pages/requests/add";
import SingleRequestPage from "./pages/requests/singleRequest";
import SingleSubRequestPage from "./pages/requests/singleSubRequest";
import SettingsHomePage from "./pages/settings";
import UsersHomePage from "./pages/users";
import UsersAddPage from "./pages/users/add";
import UsersEditPage from "./pages/users/edit";
import WalletPage from "./pages/wallet";
import PropertyEditPage from "./pages/property/edit";
import SubPropertyAddPage from "./pages/property/addSubProperty";
import PerventiveVisitsHomePage from "./pages/preventive-visits";
import PerventiveVisitsAddPage from "./pages/preventive-visits/add";
import PublicEmptyLayout from "./layouts/publicEmptyLayout";
import AccountSuccess from "./pages/auth/accountSuccess";
import AccountFailure from "./pages/auth/accountFailure";
import BeneficiariesHomePage from "./pages/beneficiaries";
import BeneficiariesAddPage from "./pages/beneficiaries/add";
import BeneficiariesEditPage from "./pages/beneficiaries/edit";
import InventoryHomePage from "./pages/inventory";
import InventoryAddPage from "./pages/inventory/add";
import InventoryEditPage from "./pages/inventory/edit";
import AssetsHomePage from "./pages/assets";
import AssetsAddPage from "./pages/assets/add";
import AssetsEditPage from "./pages/assets/edit";
import PerventiveVisitsSinglePage from "./pages/preventive-visits/single";
import NotificationsCenterPage from "./pages/notifications-center";
import NotificationAddPage from "./pages/notifications-center/add";
import PaymentRequestsHomePage from "./pages/payment-requests";
import PaymentRequestsAddPage from "./pages/payment-requests/add";
import MarketPlaceHomePage from "./pages/marketplace";
import StoreHomePage from "./pages/marketplace/store";
import ProductPage from "./pages/marketplace/product";
import CartPage from "./pages/marketplace/cart";
import PaymentRequestsEditPage from "./pages/payment-requests/edit";
import ReportsHomePage from "./pages/reports";
import ForgetPasswordPage from "./pages/auth/ForgotPassword";
import ResetPasswordPage from "./pages/auth/ResetPassword";
import ResetPasswordSuccess from "./pages/auth/ResetPasswordSuccess";
import MarketPlaceOrdersPage from "./pages/marketplace/orders";

const routesConfig = [
    {
        element: <AuthLayout />,
        children: [
            {
                path: "/:lng/login",
                element: <LoginPage />,
            },
            {
                path: "/:lng/register/:packageId",
                element: <RegisterPage />,
            },
            {
                path: "/:lng/forgot-password",
                element: <ForgetPasswordPage />,
            },
            {
                path: "/:lng/reset-password",
                element: <ResetPasswordPage />,
            }
        ],
    },
    {
      element: <AppLayout />,
      children: [
        {
          path: "/:lng/",
          element: <HomePage />,
        },
        {
            path: "/",
            element: <HomePage />,
        },
        {
            path: "/:lng/dashboard",
            element: <HomePage />,
        },
        {
          path:'/:lng/users',
          element: <UsersHomePage />
        },
        {
          path:'/:lng/users/add',
          element: <UsersAddPage />
        },
        {
          path:'/:lng/users/edit/:id',
          element: <UsersEditPage />
        },
        {
          path:'/:lng/beneficiaries',
          element: <BeneficiariesHomePage />
        },
        {
          path:'/:lng/beneficiaries/add',
          element: <BeneficiariesAddPage />
        },
        {
          path:'/:lng/beneficiaries/edit/:id',
          element: <BeneficiariesEditPage />
        },
        {
          path:'/:lng/property',
          element: <PropertyHomePage />
        },
        {
          path:'/:lng/property/:id',
          element: <SingleProperty />
        },
        {
          path:'/:lng/property/add',
          element: <PropertyAddPage />
        },
        {
          path:'/:lng/unit/:id',
          element: <SingleUnit />
        },
        {
          path:'/:lng/property/:id/addUnit',
          element: <UnitAddPage />
        },
        {
          path:'/:lng/property/edit/:id',
          element: <PropertyEditPage />
        },
        {
          path:'/:lng/property/addSubProperty/:id',
          element: <SubPropertyAddPage />
        },
        {
          path:'/:lng/unit/edit/:id',
          element: <UnitEditPage />
        },
        {
          path:'/:lng/preventive-visits',
          element: <PerventiveVisitsHomePage />
        },
        {
          path:'/:lng/preventive-visits/add',
          element: <PerventiveVisitsAddPage />
        },
        {
          path:'/:lng/preventive-visits/:id',
          element: <PerventiveVisitsSinglePage />
        },
        {
          path:'/:lng/messages',
          element: <MessagesHomePage />
        },
        {
          path:'/:lng/requests',
          element: <RequestsHomePage />
        },
        {
          path:'/:lng/requests/:id',
          element: <SingleRequestPage />
        },
        {
          path:'/:lng/subRequest/:id',
          element: <SingleSubRequestPage />
        },
        {
          path:'/:lng/requests/add',
          element: <RequestAddPage />
        },
        {
          path:'/:lng/maintenance',
          element: <MaintenanceHomePage />
        },
        {
          path:'/:lng/help',
          element: <HelpHomePage />
        },
        {
          path:'/:lng/settings',
          element: <SettingsHomePage />
        },
        {
          path:'/:lng/wallet',
          element: <WalletPage />
        },
        {
          path:'/:lng/inventory',
          element: <InventoryHomePage />
        },
        {
          path:'/:lng/inventory/add',
          element: <InventoryAddPage />
        },
        {
          path:'/:lng/inventory/edit/:id',
          element: <InventoryEditPage />
        },
        {
          path:'/:lng/assets',
          element: <AssetsHomePage />
        },
        {
          path:'/:lng/assets/add',
          element: <AssetsAddPage />
        },
        {
          path:'/:lng/assets/edit/:id',
          element: <AssetsEditPage />
        },
        {
          path:'/:lng/notifications-center',
          element: <NotificationsCenterPage />
        },
        {
          path:'/:lng/notifications-center/add',
          element: <NotificationAddPage />
        },
        {
          path:'/:lng/payment-requests',
          element: <PaymentRequestsHomePage />
        },
        {
          path:'/:lng/payment-requests/add',
          element: <PaymentRequestsAddPage />
        },
        {
          path:'/:lng/payment-requests/edit/:id',
          element: <PaymentRequestsEditPage />
        },
        {
          path:'/:lng/marketplace',
          element: <MarketPlaceHomePage />
        },
        {
          path:'/:lng/orders',
          element: <MarketPlaceOrdersPage />
        },
        {
          path:'/:lng/marketplace/store/:id',
          element: <StoreHomePage />
        },
        {
          path:'/:lng/marketplace/store/:storeId/product/:id/:storeProductId',
          element: <ProductPage />
        },
        {
          path:'/:lng/marketplace/cart',
          element: <CartPage />
        },
        {
          path:'/:lng/reports',
          element: <ReportsHomePage />
        },
      ],
    },
    {
      element: <EmptyLayout />,
      children: [
        {
          path: "*",
          element: <NotFoundPage />,
        },
        {
          path: "/:lng/register-success",
          element: <RegisterSuccess />
        }
      ],
    },
    {
      element: <PublicEmptyLayout />,
      children: [
        {
          path: "/:lng/account-success",
          element: <AccountSuccess />
        },
        {
          path: "/:lng/account-failure",
          element: <AccountFailure />
        },
        {
          path: "/:lng/reset-password-success",
          element: <ResetPasswordSuccess />
        }
      ],
    },
  ];

  export default routesConfig;